import { useQuery } from '@tanstack/react-query';
import { ProcessCycleStatus } from 'abi-lcm-common-types';

import { lcmApi } from '~/shared/services/api';

export const GET_PROCESS_CYCLE_STATUS_QUERY_KEY =
  'homeV2/useGetWidgetProcessCycleStatus';

export async function getWidgetProcessCycleStatus(
  token?: string
): Promise<ProcessCycleStatus> {
  const { data } = await lcmApi.get<ProcessCycleStatus>(
    '/widgets/process-cycle/status',
    {
      ...(token && {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }
  );

  return data;
}

export function useGetWidgetProcessCycleStatus() {
  return useQuery({
    queryKey: [GET_PROCESS_CYCLE_STATUS_QUERY_KEY],
    queryFn: () => getWidgetProcessCycleStatus(),
  });
}
